import { StyledOrgsSelector } from './OrgsSelector.style';
import Separator from '../Separator';
import OrgDetails from '../OrgDetails';

const OrgsSelector = ({ orgs, onOrgSelected }) => {
  return (
    <StyledOrgsSelector>
      <Separator />
      {orgs.map(org => {
        return (
          <OrgDetails
            key={org.name}
            orgName={org.name}
            imageUrl={org.imageUrl}
            isSelected={org.isSelected}
            onOrgSelected={() => onOrgSelected(org)}
            showCheck={true}
          ></OrgDetails>
        );
      })}
    </StyledOrgsSelector>
  );
};

export default OrgsSelector;
